import React from 'react';
import { Box, Flex, Skeleton } from '@skin-seoul/design-system';
export const LoyaltyBannerSkeletonMobile = () => {
  return <Box position="relative" width="100%" height="112px" borderRadius="12px" bg="neutral.100" overflow="hidden" data-sentry-element="Box" data-sentry-component="LoyaltyBannerSkeletonMobile" data-sentry-source-file="LoyaltyBannerSkeleton.Mobile.tsx">
      <Flex position="relative" height="100%" alignItems="center" justifyContent="space-between" px={4} zIndex={1} data-sentry-element="Flex" data-sentry-source-file="LoyaltyBannerSkeleton.Mobile.tsx">
        {/* Left Side - Title Skeleton */}
        <Flex direction="column" gap={1} data-sentry-element="Flex" data-sentry-source-file="LoyaltyBannerSkeleton.Mobile.tsx">
          <Skeleton height="20px" width="80px" data-sentry-element="Skeleton" data-sentry-source-file="LoyaltyBannerSkeleton.Mobile.tsx" />
          <Skeleton height="20px" width="100px" data-sentry-element="Skeleton" data-sentry-source-file="LoyaltyBannerSkeleton.Mobile.tsx" />
        </Flex>

        {/* Right Side - Points Skeleton */}
        <Skeleton height="32px" width="100px" data-sentry-element="Skeleton" data-sentry-source-file="LoyaltyBannerSkeleton.Mobile.tsx" />
      </Flex>
    </Box>;
};